import Vue from 'vue'

export default {
  setLoading (state, payload) {
    state.loading = payload
  },
  setAdminOperations (state, payload) {
    state.adminOperations = payload
  },
  setAdminLogs (state, payload) {
    state.adminLogs = payload
  },
  setPagination (state, payload) {
    state.pagination = { ...payload }
  },
}
